import {
  IDictButtonControl,
  IDictDateInputControl,
  IDictInputControl,
  IDictMultilineTextInputControl,
} from '@infotech-soe/metaschema';

import { ControlWithBaseDictionary } from '../../../view-model/FormControlViewModel';
import {
  CategoryFormSource,
  ConditionFormSource,
  FormSource,
} from '../../../view-model/FormSource';

import { getAppDisplayModeName } from './getAppDisplayModeName';

export const buildCommonDictionaryButtonModel = (
  {
    category,
    displayMode,
    fullHierarchy,
    hideTree,
    inParams = {},
  }:
    | IDictButtonControl
    | IDictDateInputControl
    | IDictInputControl
    | IDictMultilineTextInputControl,
  source: FormSource
): ControlWithBaseDictionary => ({
  category: category || source.category,
  displayMode: getAppDisplayModeName(
    (source as CategoryFormSource | ConditionFormSource).application,
    displayMode
  ),
  fullHierarchy,
  hideTree,
  inParams,
});
